<template>
  <div>
    <div v-if="isEditing">
      <el-form-item prop="title" label="题目">
        <wjQuillEditor
          :content="tempQuesData.title"
          :config="config"
          @onChange="handleEditorChange"
        ></wjQuillEditor>
      </el-form-item>
      <el-form-item label="备注">
        <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
      </el-form-item>
      <div class="chained-part">
        <div class="chained-title">
          <p v-for="(item, idx) in tempQuesData.levels" class="chained-title-item" :key="idx">
            <el-input
              v-model="item.value"
              :id="'level_' + idx"
              :placeholder="'添加' + (idx + 1) + '级标题'"
            ></el-input>
            <i class="el-icon-close del-btn" @click="handleDeleteTitle(idx)"></i>
          </p>
          <div class="addOptionBtn addChainedTitle" @click="handleAddLevel">新建标题</div>
        </div>
        <div class="chained-options">
          <div v-for="i in tempQuesData.levels.length" class="levelItems" :key="i">
            <p
              :class="{'levelItem-input': true, 'checked': item.checked}"
              v-for="(item, idx) in chainedArr[i - 1]"
              :key="idx"
              @click="handleCheckLevel(item, i)"
            >
              <el-input
                v-model="item.value"
                :id="'opt_' + item.id"
                @blur="checkRequire(i, idx, item.value)"
              ></el-input>
              <i class="el-icon-close del-btn" @click="handleDeleteOpt(i, idx)"></i>
            </p>
            <div
              v-if="typeof chainedArr[i - 1] == 'object'"
              class="addOptionBtn addChainedOpt"
              @click="handleAddOpt(i)"
            >新建选项</div>
            <p v-else class="checkTips">请点击选择上一级选项</p>
          </div>
          <div class="levelItems"></div>
        </div>
        <div class="edit-settings">
          <el-button type="text" class="addOtherBtn" @click="handleBatchChange">批量修改</el-button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="ques-title">
        {{ ques.index + 1 }}.
        <p style="display: inline-block;" v-html="ques.title"></p>
        <i v-if="ques.required" class="required-icon">*</i>
      </div>
      <p class="ques-desc">{{ ques.description }}</p>
      <div class="chianedSelects">
        <div
          v-for="(item, i) in ques.levels"
          :class="{'active': answerArr[i - 1] !== undefined && range[i].length > 0, 'chainedSelect-item': true}"
          :key="i"
        >
          <p>{{ item.value }}</p>
          <el-select @change="idx => {handleChange(i, idx)}" v-model="answerArr[i]">
            <el-option v-for="(opt, idx) in range[i]" :label="opt.value" :value="idx" :key="idx"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-dialog
      title="批量修改"
      class="batch-update-dialog"
      width="70%"
      :visible.sync="batchUpdateDialogShow"
    >
      <el-input autofocus v-model="batchOptionUpdate" type="textarea" :rows="16"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchUpdateDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import utils from "../utils";
import wjQuillEditor from "./wj-quill-editor.vue";
import { htmlToTxtMixin } from "../utils/mixins.js";
import { uuid } from "../utils/utils";
export default {
  name: "chained-selects",
  mixins: [htmlToTxtMixin],
  data() {
    return {
      chainedArr: new Array(
        this.tempQuesData ? this.tempQuesData.levels.length : 0
      ),
      answerArr: new Array(this.ques ? this.ques.levels.length : 0),
      range: new Array(this.ques ? this.ques.levels.length : 0),
      batchOptionUpdate: "",
      batchUpdateDialogShow: false
    };
  },
  mounted() {
    if (this.tempQuesData)
      this.chainedArr.splice(0, 1, this.tempQuesData.groups);
    if (this.ques) this.range.splice(0, 1, this.ques.groups);
  },
  props: ["tempQuesData", "isEditing", "ques", "config"],
  components: {
    wjQuillEditor
  },
  methods: {
    handleBatchChange() {
      this.groupsTxt = "";
      let levels = this.tempQuesData.levels;
      for (let i = 0; i < levels.length; i++) {
        this.batchOptionUpdate +=
          levels[i].value + (i === levels.length - 1 ? "\n" : " ");
      }
      this.batchUpdateDialogShow = true;
      this.testG(this.tempQuesData.groups, "");
      this.recursionGroups(this.tempQuesData.groups);
      this.batchOptionUpdate += this.groupsTxt;
    },
    handleCheckLevel(item, i) {
      for (let j = i - 1; j < this.tempQuesData.levels.length; j++) {
        this.chainedArr[j] &&
          this.chainedArr[j].forEach(val => {
            val.checked = false;
          });
      }
      item.checked = true;
      this.chainedArr.splice(i, 1, item.children);
      this.chainedArr.fill(undefined, i + 1);
    },
    handleAddOpt(i) {
      let id = uuid();
      this.chainedArr[i - 1].push({
        id: id,
        value: "",
        children: []
      });
      this.$nextTick(() => {
        document.getElementById("opt_" + id).focus();
      });
    },
    handleDeleteOpt(i, idx) {
      this.chainedArr[i - 1].splice(idx, 1);
    },
    handleDeleteTitle(idx) {
      this.tempQuesData.levels.splice(idx, 1);
      this.chainedArr[idx - 1] &&
        this.chainedArr[idx - 1].forEach(val => {
          val.children = [];
        });
      this.chainedArr.splice(idx, 1, undefined);
    },
    handleAddLevel() {
      let k = this.tempQuesData.levels.length;
      this.tempQuesData.levels.push({
        value: ""
      });
      this.$nextTick(() => {
        document.getElementById("level_" + k).focus();
      });
    },
    handleChange(i, idx) {
      this.range.splice(i + 1, 1, this.range[i][idx].children);
      this.range.fill(null, i + 2);
      this.answerArr.fill(undefined, i + 1);
    },
    confirmBatchUpdate() {
      let _arr = this.batchOptionUpdate.split("\n").map(function(a, b) {
        return {
          lineNumber: b + 1,
          lineContent: a
        };
      });
      let obj = {},
        out = [];
      let isError = this.tree2json(_arr, obj);
      if (isError) return;
      this.arr2obj(obj.groups, out);
      this.tempQuesData.groups = out;
      this.chainedArr.fill(undefined);
      this.chainedArr.splice(0, 1, this.tempQuesData.groups);
      this.tempQuesData.levels = [];
      obj.levels.forEach(val => {
        this.tempQuesData.levels.push({
          value: val
        });
      });
      this.batchUpdateDialogShow = false;
    },
    checkRequire(i, idx, val) {
      if (val === "") {
        this.handleDeleteOpt(i, idx);
      }
    },
    handleEditorChange(data) {
      this.tempQuesData.title = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.chained-part {
  padding: 0 80px;
}
.chained-title,
.chained-options {
  display: flex;
  .chained-title-item {
    flex: 1;
    margin-right: 10px;
    position: relative;
    .addChainedOpt {
      width: 100%;
      margin: 10px 0;
    }
    &:hover {
      .del-btn {
        display: block;
      }
    }
  }
  .levelItems {
    flex: 1;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
    .el-input__inner:focus {
      background-color: blue;
    }
    .addChainedOpt {
      width: 100%;
      margin: 10px 0;
    }
    .levelItem-input {
      position: relative;
      &:hover {
        .del-btn {
          display: block;
        }
      }
      &:first-child {
        margin-top: 10px;
      }
      &.checked {
        .el-input {
          border-radius: 4px;
          border: 1px solid #ff552e;
        }
        &:after {
          content: "▶";
          width: 12px;
          height: 12px;
          position: absolute;
          right: 20px;
          top: 12px;
          color: #ff552e;
        }
      }
    }
    .checkTips {
      height: 40px;
      line-height: 1.8;
      margin-top: 10px;
      text-align: center;
      flex: 1;
    }
  }
  .del-btn {
    display: none;
    position: absolute;
    cursor: pointer;
    right: 5px;
    top: 14px;
  }
  .addChainedTitle {
    flex: 1;
    margin: 0 !important;
  }
}
.chainedSelect-item {
  display: none;
  &:first-child,
  &.active {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/chained-selects.vue